let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hw4lz")).then(() => parcelRequire('13vY9'));